import React, { Component } from 'react';
import { twMerge } from 'tailwind-merge';
import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface SelectTagProps {
  value?: { label: string; value: string } | { label: string; value: string }[];
  onChange?: (e: any) => void;
  placeholder: string;
  showTagId: boolean;
  multi?: boolean;
  className?: string;
}

export default class SelectTag extends Component<SelectTagProps> {
  static defaultProps = {
    placeholder: 'Select a tag',
    showTagId: true,
  };

  async fetchTags(search: string) {
    try {
      const results = await apiFetch(null, 'corp-api/tags', {
        query: { search },
      });

      const options = results.tags.map((tag: { name: string; _id: string }) => {
        return {
          label: this.props.showTagId ? `${tag.name} (${tag._id})` : tag.name,
          value: tag._id,
        };
      });

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    const { className, ...restProps } = this.props;
    const mergedClassName = twMerge(className);

    return (
      <Select
        {...restProps}
        className={mergedClassName}
        loadOptions={this.fetchTags.bind(this)}
        ignoreCase={false}
      />
    );
  }
}
